// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fb .el-textarea textarea{width:498px;height:180px;resize:none}", ""]);
// Exports
module.exports = exports;
